import React, { Component } from 'react';
import { parserText } from '../../../config/utils';
import { GET, getJadwalDiajukan, POST, setUlangJadwal, setBatalJadwal, UseApiJadwal } from '../../../services/api-services/jadwal-api';
import { sendMessage } from '../../../config/utils/message';
import { validasiKrs } from '../../../services/api-services/krs-api';
import $ from 'jquery';

class PilihJadwal extends Component {
    state = {
        user: {
            angkatan: '',
            jurusan: '',
            kdjur: '',
            kurikulum: '',
            nama: '',
            nim: '',
            semester: '',
            smtta: '',
            ta: ''
        },
        OptJadwal: [],
        listJadwalDiajukan: [],
        checkListPengajuan: [],
        checkListOpt: [],
        isLoading: false
    }

    cekKRS = async () => {
        const params = this.props.location.state

        const response = await validasiKrs(params.idangkt, params.idjalur)
        if (response.data.ispengajuan) {
            this.getAllData(params)
        } else {
            sendMessage(413)
        }
    }

    getAllData = async (params) => {
        $('.cekJadwal').prop("checked", false);

        const allPromise = Promise.all([
            UseApiJadwal(GET, params),
            getJadwalDiajukan(params)
        ])

        const promises = await allPromise
        this.setState({
            OptJadwal: promises[0].data,
            listJadwalDiajukan: promises[1].data,
            checkListOpt: [],
            checkListPengajuan: [],
        })
    }

    toggleOpt = (event, selectedVal) => {
        const data = {
            idkrs: selectedVal.idkrs,
            idjadwal: selectedVal.idjadwal
        }

        if (event.target.checked) {
            this.state.checkListOpt.push(data)
        } else {
            var index = this.state.checkListOpt.findIndex(x => x.idjadwal === data.idjadwal);
            this.state.checkListOpt.splice(index, 1);
        }
    }

    togglePengajuan = (event, selectedVal) => {
        const data = {
            idkrs: selectedVal.idkrs,
            idjadwal: selectedVal.idjadwal
        }

        if (event.target.checked) {
            this.state.checkListPengajuan.push(data)
        } else {
            var index = this.state.checkListPengajuan.findIndex(x => x.idjadwal === data.idjadwal);
            this.state.checkListPengajuan.splice(index, 1);
        }
    }

    ProcessSimpan = async () => {
        const user = this.props.location.state
        const { checkListOpt } = this.state

        if (checkListOpt.length === 0) {
            sendMessage(408)
        }
        else {
            this.setState({ isLoading: true })

            const response = await UseApiJadwal(POST, user, checkListOpt)
            if (response) {
                sendMessage(response.data.status_code)
                    .then(() => {
                        this.getAllData(user)
                        this.setState({ isLoading: false })
                    })
            }
        }
    }

    setBatal = async () => {
        const { user, checkListPengajuan } = this.state

        if (checkListPengajuan.length === 0) {
            sendMessage(408)
        }
        else {
            this.setState({ isLoading: true })

            const response = await setBatalJadwal(checkListPengajuan)
            if (response) {
                sendMessage(response.data[0].status_code)
                    .then(() => {
                        this.getListJadwal(user)
                        this.setState({ isLoading: false })
                    })
            }
        }
    }

    setUlang = async () => {
        const user = this.props.location.state
        const { checkListPengajuan } = this.state

        if (checkListPengajuan.length === 0) {
            sendMessage(408)
        }
        else {
            this.setState({ isLoading: true })

            const response = await setUlangJadwal(checkListPengajuan)
            if (response) {
                sendMessage(response.data[0].status_code)
                    .then(() => {
                        this.getAllData(user)
                        this.setState({ isLoading: false })
                    })
            }
        }
    }

    componentDidMount = () => {
        this.cekKRS();
    }

    render() {
        const { angkatan, jurusan, nama, nim, semester, ta } = this.props.location.state
        const { listJadwalDiajukan, OptJadwal, isLoading } = this.state

        return (
            <div className="smooth mb-2">
                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-12 col-xl-8 mb-xl-0">
                            <p className="abu" style={{ fontSize: "15px", fontWeight: "bold", color: "#999999", textTransform: "capitalize" }}>
                                Akademik&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Jadwal Perkuliahan&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Pilih Jadwal
                            </p>
                        </div>
                    </div>
                </div>

                <div className="card card-custom">
                    <div className="card-body">
                        <p className="card-title text-center" style={{ fontSize: "25px", marginTop: "10px", marginBottom: "35px" }}>
                            Pilih Jadwal
                        </p>
                        <div className="table-responsive">
                            <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                                <thead></thead>
                                <tbody>
                                    <tr>
                                        <td>NIM</td>
                                        <td> : </td>
                                        <td>{nim}</td>

                                        <td>Angkatan</td>
                                        <td> : </td>
                                        <td>{angkatan}</td>
                                    </tr>
                                    <tr>
                                        <td>Nama</td>
                                        <td> : </td>
                                        <td>{parserText(nama)}</td>

                                        <td>Tahun Akademik</td>
                                        <td> : </td>
                                        <td>{ta}</td>
                                    </tr>
                                    <tr>
                                        <td>Prodi</td>
                                        <td> : </td>
                                        <td>{jurusan}</td>
                                        <td>Semester</td>
                                        <td> : </td>
                                        <td>{semester}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <br />
                        <br />
                        <p className="card-title" style={{ fontSize: "17px", marginLeft: "10px" }}>
                            Jadwal Yang Dipilih :
                        </p>
                        {OptJadwal.length === 0 && (
                            <label className="text-primary" style={{ fontSize: "15px", marginLeft: "10px" }}>
                                Pastikan jadwal telah sesuai, jika sudah terpilih semua tidak dapat dirubah kembali. jika ada perubahan pada jadwal, silahkan untuk menghubungi bagian akademik. &nbsp;
                                <a href="https://wa.me/6285175134514" target="_blank" rel="noopener noreferrer">
                                   Klik disini
                                </a>
                            </label>
                        )}

                        {/* <div className="table-responsive">
                            <table className="display expandable-table tableBord" style={{ width: "100%" }}>
                                <thead></thead>
                                <tbody>
                                    <tr>
                                        <td width="180px">Total SKS MK Aktif</td>
                                        <td width="10px"> : </td>
                                        <td width="250px">9</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div> */}
                        <div className="table-responsive mt-3">
                            <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <th>
                                            Pilih
                                        </th>
                                        <th>No</th>
                                        <th>Kode MK</th>
                                        <th>Mata Kuliah</th>
                                        <th>SKS Teori</th>
                                        <th>SKS Praktek</th>
                                        <th>Kode Dosen</th>
                                        <th>Periode</th>
                                        <th>Ruang</th>
                                        <th>Hari</th>
                                        <th>Jam</th>
                                        <th>Kelas</th>
                                        <th>Status Kelas</th>
                                        <th>B/U</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        listJadwalDiajukan.length !== 0 ?
                                            listJadwalDiajukan.map((v, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>
                                                            <input type="checkbox"
                                                                className="cekJadwal"
                                                                onChange={(e) => this.togglePengajuan(e, v)} />
                                                        </td>
                                                        <td>{index + 1}</td>
                                                        <td>{v.kodemk}</td>
                                                        <td>{v.namamk}</td>
                                                        <td>{v.sksteori}</td>
                                                        <td>{v.skspraktek}</td>
                                                        <td><a href='#' title={v.namadosen}>{v.kddosen}</a></td>
                                                        <td>{v.jalur === "Malam" ? v.periode : '-'}</td>
                                                        <td>{v.ruangan}</td>
                                                        <td>{v.hari}</td>
                                                        <td>{v.jam}</td>
                                                        <td>{v.kelas}</td>
                                                        <td>{v.statuskelas}</td>
                                                        <td>{v.bu}</td>
                                                    </tr>
                                                )
                                            }) : <tr><td colSpan={14} className="text-center">Tidak Ada Data</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                        <br />
                        {OptJadwal.length > 0 && (
                            <p align="right">
                                <button className="btn btn-danger" onClick={this.setUlang} disabled={isLoading}>
                                    set ulang
                                </button>
                            </p>
                        )}
                    </div>
                </div>

                {/* pilihan jadwal  */}
                <div className="card card-custom mt-3">
                    <div className="card-body">
                        <p className="card-title" style={{ fontSize: "16px", marginTop: "10px", marginBottom: "25px", marginLeft: '0.5%' }}>
                            Pilihan Jadwal Kuliah :
                        </p>
                        <div className="table-responsive">
                            <table id="Jadwal" className="display expandable-table tableBord table-striped" style={{ width: '100%' }}>
                                <thead>
                                    <tr>
                                        <th>
                                            Pilih
                                        </th>
                                        <th>
                                            No
                                        </th>
                                        <th>Kode MK</th>
                                        <th>Mata Kuliah</th>
                                        <th>SKS Teori</th>
                                        <th>SKS Praktek</th>
                                        <th>Nama Dosen</th>
                                        <th>Periode</th>
                                        <th>Ruang</th>
                                        <th>Hari</th>
                                        <th>Jam</th>
                                        <th>Kelas</th>
                                        <th>Isi Kelas</th>
                                        <th>Status Kelas</th>
                                        <th>B/U</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        OptJadwal.length !== 0 ?
                                            OptJadwal.map((v, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td><input type="checkbox"
                                                            className="cekJadwal"
                                                            onChange={(e) => this.toggleOpt(e, v)} /></td>
                                                        <td>
                                                            {index + 1}
                                                        </td>
                                                        <td>{v.kodemk}</td>
                                                        <td>{v.namamk}</td>
                                                        <td>{v.sksteori}</td>
                                                        <td>{v.skspraktek}</td>
                                                        <td>{v.dosen}</td>
                                                        <td>{v.jalur === "Malam" ? v.periode : '-'}</td>
                                                        <td>{v.ruangan}</td>
                                                        <td>{v.hari}</td>
                                                        <td>{v.jam}</td>
                                                        <td>{v.kelas}</td>
                                                        <td>{v.isi}</td>
                                                        <td>{v.statuskelas}</td>
                                                        <td>{v.bu}</td>
                                                    </tr>
                                                )
                                            }) : <tr><td colSpan={15} className="text-center">Tidak Ada Data</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                        <br />
                        <p align="right">
                            {OptJadwal.length > 0 &&
                                <button className="btn btn-success" id="btnSimpan" onClick={this.ProcessSimpan} disabled={isLoading}>
                                    simpan jadwal
                                </button>
                            }
                        </p>
                    </div>
                </div>
                {/* end pilihan jadwal  */}
            </div>
        );
    }
}

export default PilihJadwal;